export { useDownloadGateway } from './hook';
export { RESOLUTION_ORDER } from './types';
// Leaks `internal/` into the public surface for pre-migration callers that
// need the LUT predicate without going through `useDownloadGateway`. Remove
// once those legacy paths are retired.
export { assetGroupIsLut } from './internal/assetGroupIsLut';

export {
  useAssetUpsellTrigger,
  useCloseUpsellModal,
  useIsUpsellModalOpen,
  useUpsellModalState,
} from './upsell';

export type { UpsellReason } from './types';

export type { AssetInfo, Plan } from './upsell-types';
